import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const MERCHANT_TOKEN_KEY = "neptune_merchant_token";

export const merchantTokenStore = {
  get: () => { try { return localStorage.getItem(MERCHANT_TOKEN_KEY); } catch { return null; } },
  set: (t) => { try { localStorage.setItem(MERCHANT_TOKEN_KEY, t); } catch { /* ignore */ } },
  clear: () => { try { localStorage.removeItem(MERCHANT_TOKEN_KEY); } catch { /* ignore */ } },
};

// A dedicated axios instance — separate from the admin one so the admin
// Bearer token never bleeds into merchant requests (and vice-versa).
const merchantApi = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

merchantApi.interceptors.request.use((config) => {
  const token = merchantTokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default merchantApi;
